import React from 'react';

import { Page, Control, Divider, Panel } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StreamListTable from './StreamListTable';

function StreamListPage({
  onAddStreamClick,
  onEditStreamClick,
}) {
  const { t } = useTranslation();

  const actions = (
    <Control.Button onClick={onAddStreamClick}>
      {t('lunaStreamsStreams:таблица.добавить')}
    </Control.Button>
  );

  return (
    <Page actions={actions} title={t('lunaStreamsStreams:название раздела')}>
      <Divider />
      <Panel>
        <StreamListTable
          onAddStreamClick={onAddStreamClick}
          onEditStreamClick={onEditStreamClick}
        />
      </Panel>
    </Page>
  );
}

StreamListPage.propTypes = {
  onAddStreamClick: PropTypes.func.isRequired,
  onEditStreamClick: PropTypes.func.isRequired,
};

export default StreamListPage;
